import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import Spacer from '../Spacer';

const PageLoader = () => {
  return (
    <StyledPageLoader>
      <HeaderSkeleton />
    </StyledPageLoader>
  );
};

export default PageLoader;

export const HeaderSkeleton = () => {
  return (
    <div className="top-nav">
      {/* <div className="header">
        <Skeleton height={30} width={250} />
      </div> */}
      <div className="action-bar">
        <div className="steps">
          <Skeleton height={25} width={100} />
          <Spacer />
          <Skeleton height={25} width={100} />
          <Spacer />
          <Skeleton height={25} width={100} />
          <Spacer />
          <Skeleton height={25} width={100} />
        </div>
        <div className="actions">
          <Skeleton height={25} width={80} />
          <Spacer />
          <Skeleton height={25} width={65} />
          <Spacer />
          <Skeleton height={25} width={65} />
        </div>
      </div>
    </div>
  );
};
export const StyledPageLoader = styled.div`
  .top-nav {
    background-color: #f7f9fa;
    border-bottom: 1px var(--color-smoke-100) solid;
    padding: 0 15px;
    box-shadow: 0 2px 4px 0 rgb(24 50 71 / 8%);
    height: 56px;

    .steps {
      display: flex;
      align-items: center;
    }

    .header {
      padding: 20px 0 10px 10px;
    }
    .action-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px 10px 10px;

      .actions {
        display: flex;
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    background: #ebeff3;
  }

  .menu {
    width: 700px;
    display: flex;
    align-items: flex-start;
    .add-placeholder {
      background: #ffffff;
      border: 1px solid #ebeff3;
      box-shadow: 0px 4px 4px rgba(18, 52, 77, 0.06);
      border-radius: 50%;
      width: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      line-height: 0.5;
      height: 55px;
      cursor: pointer;
      span {
        display: block;
        margin-top: -4px;
      }
    }
  }
  .card-placehoder {
    width: 700px;
    padding: 20px;
    background: #ffffff;
    border: 1px solid #ebeff3;
    box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.1);
    border-radius: 8px;
    .action {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`;
